import { __rest } from "tslib";
import * as React from 'react';
import { st, classes } from './Text.st.css';
import { TPAComponentsConsumer, TPAComponentsContext, } from '../TPAComponentsConfig';
import { TextPriority, TextTypography } from './types';
const DEFAULT_TAG_NAME = 'span';
export class Text extends React.Component {
    render() {
        const _a = this.props, { typography, priority, tagName, children, className, role, id, 'aria-label': ariaLabel, 'aria-hidden': ariaHidden } = _a, rest = __rest(_a, ["typography", "priority", "tagName", "children", "className", "role", "id", 'aria-label', 'aria-hidden']);
        const isAriaHidden = ariaHidden && ariaHidden !== 'false';
        return (React.createElement(TPAComponentsConsumer, null, ({ mobile }) => (React.createElement(React.Fragment, null,
            React.createElement(tagName || DEFAULT_TAG_NAME, Object.assign({ className: st(classes.root, {
                    typography,
                    priority,
                    mobile,
                }, className), 'aria-hidden': isAriaHidden || !!ariaLabel, 
                // for backwards compatibility
                'aria-label': ariaLabel, 'data-hook': this.props['data-hook'], role,
                id }, rest), children),
            !isAriaHidden && ariaLabel ? (React.createElement("span", { className: classes['sr-only'], "data-sr-only": "true", "data-hook": `${this.props['data-hook'] || 'wut-text'}-aria-label` }, ariaLabel)) : null))));
    }
}
Text.contextType = TPAComponentsContext;
Text.displayName = 'Text';
Text.defaultProps = {
    typography: TextTypography.runningText,
    priority: TextPriority.primary,
};
//# sourceMappingURL=Text.js.map